export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const HOME  = 'Home';
export const ESCAPE = 'Escape';
export const TAB = 'Tab';
